import { render, staticRenderFns } from "./AdminTextForm.vue?vue&type=template&id=3f839015"
import script from "./AdminTextForm.vue?vue&type=script&lang=js"
export * from "./AdminTextForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports